import { atom } from "recoil";
import { AtomKeys } from "../const/recoilKeys";

export const AuthCheckTypeState = atom<string>({
  key: AtomKeys.AUTH_CHECK_TYPE_STATE,
  default: "",
});
